import { observable, action } from 'mobx';
import Device from './device';

type NavStyles = 'default' | 'transparent' | 'dark' | 'primary';

const isBrowser = typeof window !== 'undefined';

export class UI {
    userAgent: string;
    // 是否为APP
    isTiger: boolean;

    // 是否是移动端
    isMobile: boolean;

    isIOS: boolean;
    isAndroid: boolean;
    isWeiXin: boolean;
    isWeiBo: boolean;
    isQQ: boolean;

    constructor(userAgent?: string) {
        this.userAgent = userAgent || (isBrowser ? window.navigator.userAgent : '');
        this.isTiger = /ihuhoo|tradeup|tigerbrokers|marsco/i.test(this.userAgent);

        this.isIOS = /iphone|ipad|ipod|ios/i.test(this.userAgent);
        this.isAndroid = /android/i.test(this.userAgent);
        // 判断是否是微信环境
        this.isWeiXin = /micromessenger/i.test(this.userAgent);
        this.isWeiBo = /weibo/i.test(this.userAgent);
        this.isQQ = /qq/i.test(this.userAgent);

        this.isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobuserAgentile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
            this.userAgent
        );
    }

    device = new Device();

    // 页面pid
    @observable pid: string = '';
    @action
    setPid(pid: string) {
        this.pid = pid;
    }

    // 导航栏的样式
    @observable navTheme: NavStyles = 'default';

    @action
    setNavTheme(navTheme: NavStyles) {
        this.navTheme = navTheme;
    }

    // 隐藏头尾
    @observable clearMode: boolean = false;

    @action
    setClearMode(isClear: boolean) {
        this.clearMode = isClear;
    }

    // 复制 ui 对象上的属性
    __clone(options: UI) {
        Object.keys(options).forEach(key => {
            this[key] = options[key];
        });
    }
}

let curUi = new UI();

// 客户端渲染时，同步server端注入的数据
if (isBrowser && window.__DATA__?.ui) {
    curUi.__clone(window.__DATA__.ui);
}

export default curUi;
